import { AuthGuardService } from './service/auth-guard.service';
import { DialogComponent } from './features/dialog/dialog.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { UserIdleModule } from 'angular-user-idle';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { FeaturesModule } from './features/features.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [
    AppComponent

  ],
  imports: [
    BrowserModule,
    //UserIdleModule.forRoot({ idle: 1200, timeout: 1, ping: 1 }),// For a fast time-out //
    UserIdleModule.forRoot({idle: 1200, timeout: 5, ping: 60}),
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    FeaturesModule,
    NgbModule.forRoot()
  ],
  providers: [HttpClient, AuthGuardService],
  bootstrap: [AppComponent],
  entryComponents: [DialogComponent],
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts